export default class FeedbackModel {
  work_orders_id: number;
  duration_time_min: number | null;
  production_shift_on_downtime_min: number | null;
  report_explanation: string;
  attachment: Array<{ path: string | null;  label: string | null }>;
  material_usage?: Array<{ material_id: number; qty_actual: number }>;
  time_to_repair?: number;
  time_to_action?: number;
  time_between_failure?: number;
  time_total_stopage?: number;
  date_issue?: string | Date | null;
  date_issued_at?: string | Date;
  subject?: string;
  materials?: any;
  feedback_id?: number;

  constructor(data: any = {}) {
    this.work_orders_id = data.work_orders_id || "";
    this.duration_time_min = data.duration_time_min || null;
    this.production_shift_on_downtime_min = data.production_shift_on_downtime_min || null;
    this.report_explanation = data.report_explanation || "";
    this.attachment = data.attachment || [];
    this.material_usage = data.material_usage;
    
  }
}

